export const nestedStockTransferHeaders = {
  DocNum: {
    name: "documentNo",
    width: 0.4,
    textAlign: "left",
  },
  ItemCode: {
    name: "itemCode",
    width: 0.5,
    textAlign: "left",
  },
  Dscription: {
    name: "description",
    width: 0.7,
    textAlign: "left",
  },
  DeliveryAddress: {
    name: "address",
    width: 1.0,
    textAlign: "left",
  },
  ProductGroup: {
    name: "productGroup",
    width: 0.5,
    textAlign: "left",
  },
  RemainingQty: {
    name: "remainingQty",
    width: 0.5,
    textAlign: "left",
  },
};

export const mdNestedStockTransferHeaders = {
  DocNum: {
    name: "documentNo",
    width: 0.4,
    textAlign: "left",
  },
  ItemCode: {
    name: "itemCode",
    width: 0.5,
    textAlign: "left",
  },
  DeliveryAddress: {
    name: "address",
    width: 0.7,
    textAlign: "left",
  },
  RemainingQty: {
    name: "remainingQty",
    width: 0.5,
    textAlign: "left",
  },
};

export const nestedHeaders = {
  DocNum: {
    name: "documentNo",
    width: 0.4,
    textAlign: "left",
  },
  ItemCode: {
    name: "itemCode",
    width: 0.5,
    textAlign: "left",
  },
  Dscription: {
    name: "description",
    width: 1.0,
    textAlign: "left",
  },
  DeliveryAddress: {
    name: "address",
    width: 1.5,
    textAlign: "left",
  },
  'CustomerRef.': {
    name: "reference",
    width: 0.7,
    textAlign: "left",
  },
  ProductGroup: {
    name: "productGroup",
    width: 0.6,
    textAlign: "center",
  },
  OrderQty: {
    name: "orderQty",
    width: 0.6,
    textAlign: "center",
  },
  DelivrdQty: {
    name: "deliveryQty",
    width: 0.6,
    textAlign: "center",
  },
  RemainingQty: {
    name: "remainingQty",
    width: 0.6,
    textAlign: "center",
  },
  NoOfPallets: {
    name: "pallets",
    width: 0.6,
    textAlign: "center",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const mdNestedHeaders = {
  DocNum: {
    name: "documentNo",
    width: 0.3,
    textAlign: "left",
  },
  ItemCode: {
    name: "itemCode",
    width: 0.5,
    textAlign: "left",
  },
  DeliveryAddress: {
    name: "address",
    width: 2.0,
    textAlign: "left",
  },
  OrderQty: {
    name: "orderQty",
    width: 1.0,
    textAlign: "center",
  },
  DelivrdQty: {
    name: "deliveryQty",
    width: 1.0,
    textAlign: "center",
  },
  RemainingQty: {
    name: "remainingQty",
    width: 1.0,
    textAlign: "center",
  },
  NoOfPallets: {
    name: "pallets",
    width: 1.0,
    textAlign: "center",
  },
  "": { name: "", width: 0.2, textAlign: "" },
};

export const smNestedHeaders = {
  DocNum: {
    name: "documentNo",
    width: 0.8,
    textAlign: "left",
  },
  ItemCode: {
    name: "itemCode",
    width: 0.8,
    textAlign: "left",
  },
  Dscription: {
    name: "description",
    width: 1.5,
    textAlign: "left",
  }
};
